import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/undraw_bug_fixing_oc7a.svg")